import { MatLegacyButton as MatButton } from '@angular/material/legacy-button';
import {
   MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
   MatLegacyDialogRef as MatDialogRef
} from '@angular/material/legacy-dialog';

import {
   Component,
   Inject,
   OnDestroy,
   OnInit,
   ViewChild
} from '@angular/core';

import { interval, Subscription } from 'rxjs';

@Component({
   selector: 'app-download-multiple-task',
   templateUrl: './download-multiple-task.component.html',
   styleUrls: ['./download-multiple-task.component.css']
})
export class DownloadMultipleTaskComponent implements OnInit, OnDestroy {

   /**
    * downloadId จาก Backend
    */
   private downloadId: string;

   /**
    * Timer
    */
   private timer: Subscription;

   /**
    * กัน downloadZip() ถูกเรียกซ้ำ (poll ที่ response ช้ากว่า 500ms อาจซ้อนกันแล้วเห็น finished พร้อมกัน
    * ขณะที่ backend ลบ zip หลังส่งครั้งแรก ครั้งที่สองจะได้ 404)
    */
   private zipRequested = false;

   /**
    * Progress %
    */
   progress = 0;

   /**
    * Error Message
    */
   error: string;

   /**
    * Task Id
    */
   private taskId = -1;

   @ViewChild('cancel')
   cancel: MatButton;

   constructor(
      private dialogRef: MatDialogRef<DownloadMultipleTaskComponent>,
      @Inject(MAT_DIALOG_DATA) private data: any
   ) {

      if (data.taskId) {
         this.taskId = data.taskId;
      }

   }

   ngOnInit(): void {

      this.startDownload();

   }

   ngOnDestroy(): void {

      if (this.timer) {
         this.timer.unsubscribe();
      }

   }

   /**
    * เริ่มสร้าง ZIP
    */
   private startDownload(): void {
      this.data.service.post(
         '/multiple/download/taskComplete?includeAuditTrail=' + this.data.includeAuditTrail,
         this.data.listTasks
      ).subscribe({

         next: (res) => {

            this.downloadId = res.downloadId;

            this.startPolling();

         },

         error: (err) => {

            this.error = err.error?.message || 'Create download failed';

         }

      });

   }

   /**
    * Poll Progress ทุก 500 ms
    */
   private startPolling(): void {

      this.timer = interval(500).subscribe(() => {

         this.checkStatus();

      });

   }

   /**
    * เช็ค Progress
    */
   private checkStatus(): void {

      this.data.service.get(
         '/multiple/download/progress/' + this.downloadId)
         .subscribe({

         next: (data) => {

            this.progress = data.percent;

            if (!data.success) {

               if (this.timer) {
                  this.timer.unsubscribe();
               }

               this.error = data.errorMessage || 'Download failed';
               return;

            }

            if (data.finished) {

               if (this.timer) {
                  this.timer.unsubscribe();
               }

               if (this.zipRequested) {
                  return;
               }

               this.zipRequested = true;

               this.progress = 100;

               if (this.cancel) {
                  this.cancel.disabled = true;
               }

               this.downloadZip();

            }

         },

         error: (err) => {

            if (this.timer) {
               this.timer.unsubscribe();
            }

            this.error = err.error?.message || 'Cannot check download status';

         }

      });

   }

   /**
    * Download ZIP
    */
   private downloadZip(): void {

      const token = this.data.service.user.token;

      window.location.href = this.data.service.url + '/multiple/download/file/' + this.downloadId + '?token=' + token;

      setTimeout(() => {

         this.dialogRef.close();

      }, 500);

   }

   /**
    * Cancel
    */
   cleanAndClose(cancel: MatButton): void {

      cancel.disabled = true;

      if (this.timer) {
         this.timer.unsubscribe();
      }

      this.dialogRef.close();

   }
}
